import React from 'react';
import Icon from '@ant-design/icons';
import Video from '@assets/img/videocamera.svg';

function VideoIcon(props) {
  return <Icon component={() => <Video {...props} />} />;
}

export default VideoIcon;
